import { useEffect, useRef } from 'react';
import type { HubConnection } from '@microsoft/signalr';
import { LoggerService } from 'services/LoggerService';
import MeetingHubEvents from 'store/enums/MeetingHubActions';

const logger = LoggerService.getLogger('MeetingHubEvent');

export function useHubEvent<TPayload = any>(
  connection: HubConnection | null,
  eventName: MeetingHubEvents,
  handler?: (payload: TPayload) => void
): void {
  const handlerRef = useRef<typeof handler>();
  handlerRef.current = handler;

  useEffect(() => {
    if (!connection || !handler) return;

    logger.info(`Registering hub handler for event "${eventName}"`);

    const wrapped = (payload: TPayload) => handlerRef.current?.(payload);
    connection.on(eventName, wrapped);

    return () => {
      logger.info(`Unregistering hub handler for event "${eventName}"`);
      connection.off(eventName, wrapped);
    };
  }, [connection, eventName, handler]);
}
